export default "__VITE_ASSET__BDkuRYU8__"